import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1C1917] text-stone-300 mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4">
            <img src="/vf-logo.jpg" alt="Vardhman Furniture" className="h-14 w-14 object-cover rounded-full ring-1 ring-stone-700"/>
            <h3 className="font-serif text-3xl text-white">Vardhman <span className="text-[#A67B5B]">Furniture</span></h3>
          </div>
          <p className="mt-4 text-stone-400 leading-relaxed max-w-md">Handcrafted furniture for home, office and hospitality. Made in India, since a lineage of woodworkers who believe in patience over polish.</p>
        </div>
        <div>
          <p className="text-xs tracking-[0.3em] uppercase text-[#A67B5B] mb-4">Shop</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop/sofa" className="hover:text-white">Sofa</Link></li>
            <li><Link to="/shop/bedroom" className="hover:text-white">Bedroom</Link></li>
            <li><Link to="/shop/living-room" className="hover:text-white">Living Room</Link></li>
            <li><Link to="/shop/dining" className="hover:text-white">Dining</Link></li>
            <li><Link to="/shop/storage" className="hover:text-white">Storage</Link></li>
            <li><Link to="/shop/study-office" className="hover:text-white">Study & Office</Link></li>
            <li><Link to="/shop/bar" className="hover:text-white">Bar Furniture</Link></li>
            <li className="pt-2 border-t border-stone-800"><Link to="/custom-order" className="hover:text-white">Custom Orders</Link></li>
            <li><Link to="/track-order" className="hover:text-white">Track Order</Link></li>
            <li><Link to="/about" className="hover:text-white">About Us</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-xs tracking-[0.3em] uppercase text-[#A67B5B] mb-4">Contact</p>
          <ul className="space-y-3 text-sm text-stone-400">
            <li data-testid="footer-address" className="flex items-start gap-2">
              <MapPin size={16} className="mt-0.5 shrink-0"/>
              <span>Shop No. 09776, Kikar Bazar, Old City, Near HDFC Bank, Bathinda, India</span>
            </li>
            <li className="flex items-start gap-2">
              <Phone size={16} className="mt-0.5 shrink-0"/>
              <span className="flex flex-col">
                <a data-testid="footer-phone-1" href="tel:+919115800091" className="hover:text-white">+91 91158 00091</a>
                <a data-testid="footer-phone-2" href="tel:+919915847157" className="hover:text-white">+91 99158 47157</a>
              </span>
            </li>
            <li className="flex items-start gap-2">
              <MessageCircle size={16} className="mt-0.5 shrink-0"/>
              <a
                data-testid="footer-whatsapp"
                href="https://wa.me/919115800091"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white"
              >WhatsApp: +91 91158 00091</a>
            </li>
            <li className="flex items-start gap-2">
              <Mail size={16} className="mt-0.5 shrink-0"/>
              <span className="flex flex-col break-all">
                <a data-testid="footer-email-1" href="mailto:surkhaabhundal444@gmail.com" className="hover:text-white">surkhaabhundal444@gmail.com</a>
                <a data-testid="footer-email-2" href="mailto:vb872833@gmail.com" className="hover:text-white">vb872833@gmail.com</a>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-stone-800">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-stone-500">
          <p>© {new Date().getFullYear()} Vardhman Furniture. Every piece, a small legacy.</p>
          <p className="tracking-widest uppercase">Crafted with patience</p>
        </div>
      </div>
    </footer>
  );
}
